import { render, staticRenderFns } from "./Ufabet.vue?vue&type=template&id=caeb40be&scoped=true"
import script from "./Ufabet.vue?vue&type=script&lang=js"
export * from "./Ufabet.vue?vue&type=script&lang=js"
import style0 from "./Ufabet.vue?vue&type=style&index=0&id=caeb40be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caeb40be",
  null
  
)

export default component.exports